import { useEffect, useState, useRef } from 'react'
import { Skeleton } from '@mercai/clever'

import { useSupplierList } from '@/services'

import { InputSearch, DropDownSearch } from './components'

import type { SupplierSearchProps } from './supplier-search.type'
import type { SupplierProps } from '@/types'

import styles from './supplier-search.module.css'

export const SupplierSearch = ({
  onSelectSupplier,
  selectedSupplier,
  error,
  maxHeightDropdown,
  title,
}: SupplierSearchProps) => {
  const [value, setValue] = useState('')
  const [isOpen, setIsOpen] = useState(false)

  const { data, isLoading } = useSupplierList({ params: { search: value } })

  const onChangeValue = (newValue: string) => {
    setValue(newValue)

    if (selectedSupplier?.uuid) {
      onSelectSupplier({})
    }
  }

  const onHandleSelectSupplier = (supplierParam: SupplierProps) => {
    setIsOpen(false)
    onSelectSupplier(supplierParam)
  }

  useEffect(() => {
    if (selectedSupplier?.name) {
      setValue(selectedSupplier?.name)
    }

    return () => {
      setValue('')
    }
  }, [selectedSupplier])

  const rootRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const closeOpennedDropDown = (e: MouseEvent) => {
      if (
        rootRef.current &&
        isOpen &&
        !rootRef.current.contains(e.target as Node)
      ) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', closeOpennedDropDown)

    return () => document.removeEventListener('mousedown', closeOpennedDropDown)
  }, [isOpen, rootRef])

  return (
    <div className={styles.core} ref={rootRef}>
      {isLoading && !isOpen ? (
        <div className={styles['wrap-skeleton']}>
          <Skeleton width="70%" height="1.25rem" />
          <Skeleton width="100%" height="2.5rem" />
        </div>
      ) : (
        <InputSearch
          onChange={onChangeValue}
          value={value}
          onOpen={setIsOpen}
          error={error}
          title={title}
        />
      )}

      <DropDownSearch
        isOpen={isOpen}
        data={data?.data?.results}
        isLoading={isLoading}
        onSelectSupplier={(supplier) =>
          onHandleSelectSupplier(supplier as SupplierProps)
        }
        selectedSupplier={selectedSupplier}
        maxHeight={maxHeightDropdown}
      />
    </div>
  )
}
